import React from 'react';
import { ConfirmationModal } from "../modals/ConfirmationModal/ConfirmationModal";

export type DirtyWarningPromptProps = {
    show: boolean;
    message?: string;
    onConfirm: () => void;
    onCancel?: () => void;
}

export const DirtyWarningPrompt: React.FC<DirtyWarningPromptProps> = (props) => {
    const message = props.message || 
        `WARNING: You have un-saved changes.
         Are you sure you want to continue?
         Click 'OK' to continue and LOSE your changes or 'Cancel' to return.`
    
    return (
        <ConfirmationModal show={props.show} onConfirm={props.onConfirm} onCancel={props.onCancel} confirmBtnText="OK">                
            <p>{message}</p>
        </ConfirmationModal>
    )
}
